import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';

import Storage from 'react-native-storage';
import i18n from 'i18n-react';
import SweetAlert from 'sweetalert-react';

import * as Sentry from '@sentry/react';

import { Integrations } from '@sentry/tracing'; 
import { SettingsProvider } from 'hooks/useSettings';

// FontAwesome
import 'config/FontAwesome';

import {
  AppSettings,
  APIHandler,
  AppRouter,
  DataHandler,
  locales,
  StorageHandler,
  MobileWarning,
  CookieWarning,
} from 'C4';
import { storageKeys, language, userKeys, sentry } from 'settings';

import 'normalize.css/normalize.css';
import './assets/styles/styles.scss';

const { cookieEnabled } = window.navigator;

Sentry.init({
  ...sentry,
  integrations: [new Integrations.BrowserTracing()],
  ignoreErrors: ['Non-Error promise rejection captured'],
});

const exportObject = cookieEnabled
  ? new Storage({
    storageBackend: cookieEnabled ? window.localStorage : {},
    defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
    enableCache: true,
    sync: {
      // TODO: Handle exiration of data (Reload data with new API Calls)
    },
  })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language.map(lang => lang.code.toLowerCase());
const commitRisk = language.some(lang => lang.id === 220 && lang.countries.length > 0);
if (commitRisk) console.error('One of the testing languages is currently in use. Please remove before committing.');

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(Object.keys(storageKeys).filter((key) => {
        const k = storageKeys[key];
        return k !== storageKeys.appId && k !== storageKeys.lang;
      }));
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.code]);
    });
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.code]);
      });
    } else {
      // Get user location and check if a language file exists.
      APIHandler.getLocation().then((location) => {
        if (location) {
          const code = location.countryCode.toLowerCase();
          const availableLanguageForUserLocation = translationFiles =>
            translationFiles.map(translation => translation[0] === code).includes(true);
          if (availableLanguageForUserLocation(availableLanguages)) {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(' ', '_'),
              code: code.toLowerCase(),
            });
            window.location.reload();
          } else {
            StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'en' });
            window.location.reload();
          }
        } else {
          StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'en', langFile: 'en' });
          i18n.setTexts(locales.en);
          window.location.reload();
        }
      });
    }
  });
  StorageHandler.load('askedMobile').then((askedBefore) => {
    ReactDOM.render(<App askedBefore={askedBefore} />, document.getElementById('root'));
  });
}

// Validate token in firebase on start and refresh (every 30 minutes), only for logged in users
function validateToken() {
  StorageHandler.load(storageKeys.user).then((user) => {
    if (user) {
      StorageHandler.load(storageKeys.refreshToken).then((localToken) => {
        if (localToken) {
          APIHandler.refreshFirebaseToken(localToken).then((token) => {
            if (token.error) {
              StorageHandler.removeKeys(userKeys);
              window.location.replace('/logout');
            } else if (token) {
              StorageHandler.save(storageKeys.refreshToken, token.refresh_token);
              StorageHandler.save(storageKeys.idToken, token.id_token, 180000);
            } else {
              StorageHandler.removeKeys(userKeys);
              window.location.replace('/logout');
            }
          });
        }
      });
    }
  });
}

setInterval(() => {
  validateToken();
}, 1000 * 60 * 30);

validateToken();

class App extends Component {
  constructor(props) {
    super(props);

    const mobileRegex = new RegExp('Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini', 'i');
    const mobilePathRegex = new RegExp('mobile', 'i');

    this.state = {
      onMobile: mobileRegex.test(window.navigator.userAgent) && !mobilePathRegex.test(window.location.pathname),
      askedBefore: this.props.askedBefore,
    };
  }

  render() {
    const { onMobile, askedBefore } = this.state;
    const params = new URLSearchParams(window.location.search);
    let header = true;
    if (params.get('header') === 'false') {
      header = false;
    }

    const setAsked = () => {
      // this.setState({ askedBefore: true });
      // StorageHandler.save('askedMobile', true);
      window.history.back();
    };

    return (
      <SettingsProvider>
        <div className="container__router">
          <AppSettings />
          {!cookieEnabled && <CookieWarning />}
          <AppRouter />
          {/* {header && onMobile && (
          <MobileWarning />
        )} */}
        </div>
      </SettingsProvider>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
